import "core-js/modules/es6.object.define-property";
import _merge from "lodash/merge";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";

var _createReducer;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { simulateVantageScore } from "../actions";
var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, simulateVantageScore.start, function (state, payload, meta) {
  var newState = _cloneDeep(state);

  _set(newState, meta.key, null);

  return newState;
}), _defineProperty(_createReducer, simulateVantageScore.success, function (state, payload) {
  return (// If we have deeply nested keys, Object.assign (or destructuring, etc) will
    // override with the newest value.
    // { ...{ foo: { tyke: 1 } }, ...{ foo: { evan: 2 } } }
    // ==> { foo: { evan: 2} }
    // which sucks, so we need to do a deep object assign
    _merge({}, state, payload)
  );
}), _defineProperty(_createReducer, simulateVantageScore.fail, function (state, payload) {
  return _merge({}, state, payload);
}), _createReducer), {});
export default reducer;